import * as React from "react";
import { Link } from "react-router-dom";

export function SearchLink({ searchTerm, displayText }) {
  return (
    <Link
      to={{
        pathname: "/main/search",
        search: `?search=${searchTerm}`,
      }}
    >
      {displayText || searchTerm}
    </Link>
  );
}
